module.exports = __webpack_public_path__ + "img/downarrow.f427b5d2.svg";